import { Link } from "react-router-dom";
import { Mail, Heart } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[var(--rts-ink)] text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2 space-y-4">
          <div className="flex items-center gap-3">
            <img src="/logo.jpg" alt="PARS logo" className="h-16 w-auto object-contain bg-white rounded-md p-1" />
            <div>
              <div className="font-display text-xl font-bold">Reversing the Stigma</div>
              <div className="text-xs text-white/60 tracking-widest uppercase">Project Addiction · PARS</div>
            </div>
          </div>
          <p className="text-white/70 text-sm leading-relaxed max-w-md">
            Stigma is a public health issue. We exist to change perceptions, change minds, and change lives - one conversation at a time.
          </p>
          <div className="flex items-center gap-4 pt-2">
            <a href="https://www.facebook.com/PARSProjectAddictionReversingtheStigma/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-10 h-10 grid place-items-center rounded-full bg-white/10 hover:bg-[var(--rts-blue)] transition" data-testid="footer-facebook">
              <i className="fa-brands fa-facebook-f" />
            </a>
            <a href="https://www.instagram.com/p._a._r._s/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-10 h-10 grid place-items-center rounded-full bg-white/10 hover:bg-[var(--rts-blue)] transition" data-testid="footer-instagram">
              <i className="fa-brands fa-instagram" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-display text-base text-white mb-4">Explore</h4>
          <ul className="space-y-1 text-sm text-white/70">
            <li><Link to="/" className="hover:text-[var(--rts-blue-light)] py-2 inline-flex items-center min-h-[44px]" data-testid="footer-link-home">Home</Link></li>
            <li><Link to="/about" className="hover:text-[var(--rts-blue-light)] py-2 inline-flex items-center min-h-[44px]" data-testid="footer-link-about">About</Link></li>
            <li><Link to="/events" className="hover:text-[var(--rts-blue-light)] py-2 inline-flex items-center min-h-[44px]" data-testid="footer-link-events">Events</Link></li>
            <li><Link to="/gallery" className="hover:text-[var(--rts-blue-light)] py-2 inline-flex items-center min-h-[44px]" data-testid="footer-link-gallery">Gallery</Link></li>
            <li><Link to="/resources" className="hover:text-[var(--rts-blue-light)] py-2 inline-flex items-center min-h-[44px]" data-testid="footer-link-resources">Resources</Link></li>
            <li><Link to="/overdose-awareness-license-plates" className="hover:text-[var(--rts-blue-light)] py-2 inline-flex items-center min-h-[44px]" data-testid="footer-link-plate">License Plate</Link></li>
            <li><Link to="/connect-with-us" className="hover:text-[var(--rts-blue-light)] py-2 inline-flex items-center min-h-[44px]" data-testid="footer-link-connect">Connect with Us</Link></li>
            <li><Link to="/accessibility" className="hover:text-[var(--rts-blue-light)] py-2 inline-flex items-center min-h-[44px]" data-testid="footer-link-accessibility">Accessibility Statement</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-base text-white mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-2">
              <Mail className="w-4 h-4 mt-0.5 shrink-0" />
              <a href="mailto:ReversingStigma@gmail.com" className="hover:text-[var(--rts-blue-light)] break-all py-2 inline-flex items-center min-h-[44px]" data-testid="footer-email">
                ReversingStigma@gmail.com
              </a>
            </li>
            <li className="text-white/60">
              <span className="block text-[var(--rts-blue-light)] font-semibold mb-1">#ReversingTheStigma</span>
              Follow the conversation.
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <p data-testid="footer-copyright">© {year} Reversing the Stigma · Project Addiction (PARS). All rights reserved.</p>
          <p className="flex items-center gap-1.5" data-testid="footer-credit">
            Website Designed By{" "}
            <a
              href="https://bp.agency"
              target="_blank"
              rel="noopener noreferrer"
              className="font-bold text-white hover:text-[var(--rts-blue-light)] underline-offset-4 hover:underline"
              data-testid="footer-brand-partners-link"
            >
              Brand Partners
            </a>
            <Heart className="w-3 h-3 text-[var(--rts-red)] fill-[var(--rts-red)]" />
          </p>
        </div>
      </div>
    </footer>
  );
}
